export default __webpack_public_path__ + "static/media/7minfitness_8.d77639ee.jpg";